import React from "react";
import { Dropdown } from "react-bootstrap";
import { Form } from "react-bootstrap";

export function DropDownItem(props) {
  return <Dropdown.Item>{props.children}</Dropdown.Item>;
}
export function DropDownDivider(props) {
  return <Dropdown.Divider />;
}

export default (props) => {
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      <i className="fas fa-ellipsis-v" />
    </a>
  ));

  const CustomMenu = React.forwardRef(
    ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
      const [value, setValue] = React.useState("");

      return (
        <div
          ref={ref}
          style={style}
          className={className}
          aria-labelledby={labeledBy}
        >
          <Form.Control
            autoFocus
            className="mx-3 my-2 w-auto"
            placeholder="Type to filter..."
            onChange={(e) => setValue(e.target.value)}
            value={value}
          />
          <ul className="list-unstyled">
            {React.Children.toArray(children).filter(
              (child) =>
                !value || child.props.children.toLowerCase().startsWith(value)
            )}
          </ul>
        </div>
      );
    }
  );

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" />
      <Dropdown.Menu>{props.children}</Dropdown.Menu>
    </Dropdown>
  );
};



// WEBPACK FOOTER //
// ./src/_components/Dropdown/index.jsx